import React from 'react';
import { DropdownTooltipText } from '@instinet-analytics/semantic-ui-components';
import chartPreview from './perfVsIndexCapsulePreview.png';

export const perfVsIndexCapsuleDescription: DropdownTooltipText = {
    body: (
        <>
            <div>
                The Performance Vs Index Capsule compares the price movement of
                the symbol versus that of an index.
            </div>
        </>
    ),
    minPreviewHeight: 180,
    previews: [
        {
            title: 'Chart',
            src: chartPreview,
            altText: 'prev-vs-index-capsule-chart-preview',
        },
    ],
};
